export default __webpack_public_path__ + "static/media/dillo-logo.f7bebba5.png";